import React, { useContext } from 'react';
import { I18nContext } from '@bingads-webui-react/i18n-context';
import { RemainingCharsValidatedTextField } from '@bingads-webui-campaign-react/remaining-chars-hint';
import { Campaign } from '@bingads-webui/campaign-odata-schemas';
import {
  entityIs,
  andComp,
  propertyIs,
} from '@bingads-webui-campaign-react/form-error';

import { ERROR_ENTITY } from '../constants';

const entityIsCampaign = entityIs(ERROR_ENTITY.Campaign);
const campaignNameProp = andComp(entityIsCampaign, propertyIs('Name'));

export const ValidatedCampaignName = () => {
  const i18n = useContext(I18nContext);

  return (
    <RemainingCharsValidatedTextField
      placeholder={i18n.getString(_TL_('Enter a name for your campaign'))}
      id="input-campaign-name"
      validationProps={{
        field: 'Name',
        schema: Campaign,
      }}
      i18n={i18n}
      formErrorProps={{ filter: campaignNameProp }}
    />
  );
};
